<section class="mask-curve-top bg-gray-light py-20">
  <div class="centered-with-padding">
    <div class="mb-1 desk:mb-4">
      <app-title [title]="data.title" size="custom-35-device-agnostic" />
    </div>
    <div class="grid grid-cols-1 gap-x-14 gap-y-9 desk:grid-cols-3">
      @for (category of formattedCategories(); track category.level1Category) {
        <div>
          <div class="mb-3 text-[17px] font-bold leading-[17px]">
            {{ category.level1Category }}{{ "GLOBAL.PUNCTUATION.COLON" | translate }}
          </div>
          <div class="flex flex-wrap gap-2">
            @for (level2Category of category.subcategories; track level2Category.name) {
              <a
                class="drop-shadow-custom block rounded-[10px] bg-anis px-6 py-1"
                [routerLink]="level2Category.url"
                routerLinkActive="bg-blue"
                >{{ level2Category.name }}</a
              >
            }
          </div>
        </div>
      }
    </div>
  </div>
</section>
